import axios from "axiosConfig";

const sendMessage = inputs => {
  return axios.post("api/contact-us/create_contact_request/", inputs);
};

const ContactUsService = {
  sendMessage,
};

export default ContactUsService;
